/**
 * Module dependencies.
 */

import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { TechnologyProps } from 'src/types/technologies';
import { fetchTechnology } from './fetch-technology';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<TechnologyProps, unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<TechnologyProps> & {
  slug: string;
};

/**
 * Action type.
 */

const actionType = ({ locale, slug }): string => {
  return `${locale}-technology-${slug}`;
};

/**
 * `useTechnology` hook.
 */

function useTechnology(options?: Options): Result {
  const { slug, ...rest } = options;
  const { locale } = useRouter();
  const variables = useMemo(
    () => ({
      locale,
      slug
    }),
    [locale, slug]
  );

  const result = useQuery(
    [actionType(variables), variables],
    () => {
      return fetchTechnology(variables);
    },
    rest
  );

  return result;
}

/**
 * Export `useTechnology` hook.
 */

export default useTechnology;
